// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30jga","label":"styles_label__PxC1f"};